import { Col, Form, Input, Modal, ModalBody, Row } from 'reactstrap';
import { Btn, H3 } from '../../AbstractElements';
import { AddCategory, Cancel, Save } from '../../Constant';
import { useAppDispatch, useAppSelector } from '../../Redux-Toolkit/Hooks';
import { setCategoryModal } from '../../Redux-Toolkit/Reducers/ContactSlice';

const CategoryCreate = () => {
  const {categoryModal} =useAppSelector((state)=>state.contact)
  const dispatch = useAppDispatch()
  const categoryToggle = () => dispatch(setCategoryModal())

  return (
    <>
      <Btn color='transparent' className='btn-category' onClick= {categoryToggle}  ><span className="title"> + {AddCategory}</span></Btn>
      <Modal fade isOpen={categoryModal} toggle={categoryToggle}>
        <div className='modal-header'>
          <H3 className='modal-title'>{AddCategory}</H3>
          <Btn color='transprant' className='btn-close' onClick= {categoryToggle}></Btn>
        </div>
        <ModalBody>
          <Form className="form-bookmark">
            <Row className='g-2'>
              <Col md="12" className="mb-3">
                <Input type="text" required placeholder="Enter category name" autoComplete="off" />
              </Col>
            </Row>
            <Btn color='secondary' onClick= {categoryToggle }>{Save}</Btn>
            <Btn color='primary' className= 'ms-1' onClick= {categoryToggle }>{Cancel}</Btn>
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};

export default CategoryCreate;